/**
 * 功能: slide录入页面左侧显示区域, 可以对slide进行拖拽
 */

<template lang="pug">
div.clearfix
  el-upload.fr(:action='GLOBAL.uploadHost+"slide/upload"'
    name="image"
    ref='upload'
    :data="{ brief: this.data.brief, outline: this.data._id }"
    :show-file-list="false"
    multiple
    :before-upload="beforeUpload"
    :headers="headers"
    accept="image/jpeg,image/png"
    :on-success="handleUploads")
    i(class="el-icon-plus" @click="handleSelect")
  draggable(v-model="data.slide" ghost-class="ghost" group="data.slide" @end="handleMove" @change="handleDrag")
    div(v-for="(slide, index) in data.slide" :key="slide._id")
      div(class="flex-img")
        div(class="el-upload-list el-upload-list--picture-card")
          div(class="el-upload-list__item is-success")
            slide-img(:url="slide.loImageUrl")
            span(class="el-upload-list__item-actions" @click="handlePreview(slide,data,index)")
              span(class="el-upload-list__item-delete")
                i(class="el-icon-delete" @click.stop="handleRemove(slide,data,index)")
</template>
<script>
import draggable from 'vuedraggable'
import api from '@/apis/slide'
import passport from '@/javascripts/passport'
import apiImg from '@/apis/commuCore'
import slideImg from './components/thumbnail'
export default {
  components: { draggable, slideImg },
  props: {
    data: Object
  },
  data () {
    return {
      headers: passport.headers(),

      outlinedata: {},
      drag: [],
      origin: '',
      originEle: '',
      target: '',
      targetEle: '',

      // 文件上传
      uploadflie: []
    }
  },

  methods: {
    // 选中当前要上传图片的目录
    handleSelect () {
      this.outlinedata = this.data
    },
    // update: 2020-12-14 ZYS
    // 删除单个slide图片
    handleRemove (slide, data, index) {
      // console.log('passport', passport.header())
      this.$confirm('此操作将永久删除该slide, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const { outline, _id } = slide
        if (_id) {
          api.deleteSlide({ outline, _id }).then(res => {
            this.handleResult(res, '删除slide', cb => {
              data.slide.splice(index, 1)
              // 删除时切换slide视图, 默认获取上一张的slide视图
              if (data.slide.length > 0) {
                const _index = index - 1 > 0 ? index - 1 : 0
                this.$bus.emit('getSlide', { id: data.slide[_index]._id, image: data.slide[_index].hiImageUrl })
              } else {
                this.$bus.emit('getSlide')
              }
            })
          })
        } else {
          data.slide.splice(index, 1)
        }
      }, () => { })
    },

    // update: 2020-12-14 ZYS
    // 批量上传slide，拿到返回数据后统一返回后端保存
    handleUploads (response, file, fileList) {
      const { brief, _id } = this.data
      // slide 数据格式
      this.uploadflie.push({ ...response, brief, outline: _id })
      if (this.uploadflie.length === fileList.length) {
        api.uploadSlide({ params: this.uploadflie, outline: _id }).then(res => {
          // 执行赋值操作
          this.handleResult(res, '上传slide', () => {
            for (const slide of res.data) {
              apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + slide.hiImageUrl).then(val => {
                slide.hiImageUrl = window.URL.createObjectURL(val)
              })
            }
            this.data.slide = this.data.slide.concat(res.data)
            this.$refs.upload.clearFiles()
            this.uploadflie = []
          })
        }).catch(err => {
          this.$message({ message: '上传失败,' + err.message, type: 'error' })
        })
      }
    },
    // 上传slide之前的检测
    beforeUpload (file) {
      const isLimit = file.size / 1024 / 1024 < 20
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isLimit || !isImage) {
        const message = !isLimit ? '上传图片大小不能超过 20MB!' : '请上传JPG/PNG格式文件!'
        this.$message({ type: 'warning', message, showClose: true })
        return isLimit
      }
    },
    // 若跨目录，则保存origin和target，在move事件里请求后端，若同一目录则可以直接在此事件中保存
    handleDrag (evt) {
      const { slide, _id: outline } = this.data
      if (evt.added !== undefined) {
        const tar = { slide, outline }
        sessionStorage.target = JSON.stringify(tar)
      }
      if (evt.removed) {
        const ori = { slide, outline }
        sessionStorage.origin = JSON.stringify(ori)
      }
      if (evt.moved) {
        sessionStorage.origin = ''
        sessionStorage.target = ''
        const dragData = {
          origin: { slide, outline },
          target: { slide, outline }
        }
        api.saveDragSlide(dragData).then(res => {
          this.handleResult(res, '保存')
        }).catch(err => {
          this.$message({ message: '保存失败！' + err, type: 'error', duration: 2000 })
        })
      }
    },
    // 跨目录拖拽的保存
    handleMove (evt) {
      if (sessionStorage.origin !== '' && !sessionStorage.target !== '') {
        const dragData = {
          origin: JSON.parse(sessionStorage.origin),
          target: JSON.parse(sessionStorage.target)
        }
        api.saveDragSlide(dragData).then(res => {
          this.handleResult(res, '保存')
          sessionStorage.target = ''
          sessionStorage.origin = ''
        }).catch(err => {
          this.$message({ message: '保存失败！' + err, type: 'error', duration: 2000 })
        })
      }
    },
    //
    handlePreview (slide, data, index) {
      const params = { image: slide.hiImageUrl, id: slide._id }
      document.querySelector('#region').scrollIntoView({ behavior: 'smooth', block: 'start' })
      this.$bus.emit('getSlide', params)
    }
  },
  watch: {
    data: {
      handler: function (val) {
        if (val && val.slide) {
          for (let i = 0; i < val.slide.length; i++) {
            apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + val.slide[i].hiImageUrl).then(res => {
              this.data.slide[i].hiImageUrl = window.URL.createObjectURL(res)
            })
          }
        }
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.ghost {
  opacity: 0.5;
}

.el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: auto;
  height: auto;
  margin: 0 8px 8px 0;
  display: inline-block;
  line-height: 0;
}

.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: block;
  position: absolute;
  right: -15px;
  top: -6px;
  width: 40px;
  height: 24px;
  background: #13ce66;
  text-align: center;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
}

.el-upload-list__item-actions :hover {
  cursor: default;
  color: #fff;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.el-icon-delete:before{
  position: absolute;
  right:10px;
  bottom:10px;
  cursor:pointer
}
</style>
